import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useSearchParam } from 'react-use';

import BigCircle from '@components/BigCircle';

import { useGetAccount } from '@hooks/api/account';
import { useSession } from '@hooks/useSession';

import AdminManagement from '@views/Admin/Management';
import AddNewProfile from '@views/ManageUsers/AddNewProfile';

import { AccountType } from 'generated/types';

const messages = defineMessages({
  title: {
    id: 'admin.users.create.title',
    defaultMessage: '{accountName}: New User',
  },
});

export default function AdminUsersCreatePage() {
  const { formatMessage } = useIntl();
  const {
    state: { activeProfile },
  } = useSession();
  const accountId = useSearchParam('account_id');
  const account_id = accountId ?? activeProfile?.account_id;
  const { data: accountData, loading: accountLoading } = useGetAccount({
    variables: { input: { account_id: account_id ?? '' } },
    skip: !account_id,
  });
  const isIndividual =
    accountData?.getAccountRecord.account_type === AccountType.individual;

  return (
    <AdminManagement.Layout
      maxContentWidth="md"
      title={formatMessage(messages.title, {
        accountName: accountData?.getAccountRecord.account_name,
      })}
      loading={accountLoading}
    >
      <BigCircle />
      {/* TODO Determine method of limiting # users added */}
      {isIndividual && <AddNewProfile account_id={account_id} maxUsers={5} />}
      {!isIndividual && (
        <AdminManagement.Users.Create.InternalUser account_id={account_id} />
      )}
    </AdminManagement.Layout>
  );
}
